import * as React from "react";
const SvgMagnifyingGlass = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", fill: "none", viewBox: "0 0 13 13", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 5, cy: 5, r: 4.35, stroke: "currentColor", strokeWidth: 1.3 }), /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeWidth: 1.3, d: "m8.46 8.54 3.292 3.293" }));
export {
  SvgMagnifyingGlass as default
};
//# sourceMappingURL=magnifying-glass.js.map
